import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import Dispatch from '../core/Dispatch';
import { PROGRAMMATIC_SCROLL_START } from './events';

gsap.registerPlugin(ScrollToPlugin);

export const isTouch = () => !document.documentElement.classList.contains('using-mouse');

export const isLivePreview = () => document.documentElement.classList.contains('is-preview') && document.documentElement.classList.contains('is-iframe');

export const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

export const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce), (update: slow)').matches;

let isScrollingTo;

export const scrollTo = (value, opts = {}) => {

    if (isScrollingTo === value) {
        return;
    }

    isScrollingTo = value;

    Dispatch.emit(PROGRAMMATIC_SCROLL_START);

    let scrollMargin;

    try {
        scrollMargin = parseInt(window.getComputedStyle(value).getPropertyValue('scroll-margin-top') || 0, 10);
    } catch (error) {
        scrollMargin = 0;
    }

    const duration = reduceMotion() ? 0 : 1;

    gsap.to(window, {
        duration,
        ease: 'Cubic.easeInOut',
        ...opts,
        scrollTo: {
            y: value,
            offsetY: scrollMargin,
            autoKill: true,
            onAutoKill() {
                isScrollingTo = null;
            }
        },
        onComplete() {
            isScrollingTo = null;
        }
    });
};
